// extracted by mini-css-extract-plugin
export default {"formWrapper":"review_formWrapper__19j6a","titleWrapper":"review_titleWrapper__FEBm9","formContainer":"review_formContainer__DrDRT","sideBarWrapper":"review_sideBarWrapper__IG6AB"};